import React, {useRef, useState} from 'react';
import './PopupInfo.css';
import DetailInfo from './DetailInfo';


const PopupInfo = ({ info, closePopup, loadDetail }) => {
    const refDetailInfo = useRef(null);
    const [showDetailInfo, setShowDetailInfo] = useState(false);
    function toggleDetailInfo () {
        //console.log('WANT MORE INFO', info);
        setShowDetailInfo(!showDetailInfo);
    }
    //console.log('LOADING POPUPINFO', info);

    return (
        <div>
            {showDetailInfo ? <DetailInfo ref={refDetailInfo} isVisible={showDetailInfo} toggleComponent={toggleDetailInfo} itemInfo={info}/> : <></>}
            <div className="popupinfo-frame">
                <div className="popupinfo-image" onClick={loadDetail} >
                    <div className="popupinfo-close" onClick={closePopup}>X</div>
                    <img src={info.media[0]}/>
                </div>
                <div className="popupinfo-content">
                    <h3>{info.displayName}</h3>
                    <p>Total price&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${(info.totalPrice * 1.0).toLocaleString()}</p>
                    <p>Total area&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{(info.totalArea * 1.0).toLocaleString()} m²</p>
                    <p>Price per m²&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${((info.pricePerSqm * 1.0).toLocaleString())}</p>
                    <button className={'popupinfo-content'} onClick={toggleDetailInfo}>See more</button>
                </div>
            </div>
        </div>
    );
};

export default PopupInfo;
